import React from 'react';

export type Props = {
  className?: string;
  disabled?: boolean;
  height?: number;
  onClick?(): void;
  width?: number;
};
export const Minus = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 4}
      className={props.className}
      onClick={props.onClick}
    >
      <path
        d='M14 2L2 2'
        stroke={props.disabled ? '#c5c4c8' : '#0F0A1B'}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});

Minus.displayName = 'Minus';
